import { render, staticRenderFns } from "./DoctorDetails.vue?vue&type=template&id=16b9b7bf&scoped=true"
import script from "./DoctorDetails.vue?vue&type=script&lang=js"
export * from "./DoctorDetails.vue?vue&type=script&lang=js"
import style0 from "./DoctorDetails.vue?vue&type=style&index=0&id=16b9b7bf&prod&scoped=true&lang=css"
import style1 from "./DoctorDetails.vue?vue&type=style&index=1&id=16b9b7bf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b9b7bf",
  null
  
)

export default component.exports